import PicGetRequest from '../PicGetRequest';
import { prtErr } from '../../utils/prt';


/* Note, the payload itself has the parms need to make the api call  */
const getParticipants = (participantEmail, event_id, authToken) => {
   
    let _self = this;
    let apiPromise  = new Promise (function resolver(resolve, reject) {   
            /* make api call */
            let getParticipantsRequest = new PicGetRequest("GetParticipants");
            getParticipantsRequest
                .setUserId(participantEmail)
                .setUri(`/event/${event_id}/participants`)
                .setAuthToken(authToken)  /* set token for internal request */
                .setLogTrace(true);
            getParticipantsRequest.exec().then((response) => {
                if (!response) {console.log(`No response => /${response}/`)}
                let participants = response.data;
                resolve(participants)
            }).catch(() => {
                /* api does not provide test for a status of 404, just return empty string*/
                let error = getParticipantsRequest.getError(); /* print notification below but propagate actual error below for debugging purposes */
                prtErr(`Error: encountered when calling getParticipants api for event id ${event_id} and participant ${participantEmail}`);
                reject(error)
            })
    }); /* end Promise */
    return apiPromise;
}

export default getParticipants;


// *********************************************

//  // getEventParticipants = () => {
//     let self = this;
//     // Pull out x-auth token ; server uses it to obtain user email
//     let userToken = getState().auth.token;
//     // Pull out event id
//     let event_id = getState().event.active._id;
  
//     /*Construct url for api call and set up header */
//     let url    = getAppConfigParm("picUrl") + `/event/${event_id}/participants`; 
//     let header = getAppConfigParm("axiosConfig", userToken);
//     // let header =  { 
//     //     headers: { 'x-auth': userToken,  'Content-Type': 'text/plain' }
//     // }
//     // /* Make api call to delete token from database */
//     axios.get(url, header)



// axios.get(url, header)
// .then(function (response) {
// let participants = response.data.participants || [];
// //TRACE &&prtMsg("Returned list of participants below");
// //TRACE &&prtVar("participants", JSON.stringify(participants,null,2));
// /* If  being called from PicInvites apge set isChecked to true. If called from PicPeople, set to false */
// let updatedParticipants = [];
// if (fromPage === "PicInvites") {
//     updatedParticipants = participants.map(participant  => { 
//         if (!participant.sentdate) {
//             participant.isChecked = true; 
//         } else {
//             participant.isChecked = false; 
//         }

//         // if (participant.sentdate === null) {participant.sentdate = "Not Sent"};
//         return participant
//     })
// } 
// if (fromPage === "PicPeople") {   /* note, disposition can be existing, new, or delete */
//     updatedParticipants = participants.map(participant  => { 
//         participant.disposition = "existing"; 
//         // if (participant.sentdate === null) {participant.sentdate = "Not Sent"};
//         return participant ;
//     })
// }
// dispatch(updateParticipants(participants));
// }).catch ((error) => {  /* TBD - this error should be logged to database */
// console.log(`Error encountered while trying to get list of participants from  in PicMuiTabs component`);
// console.log(error);
// dispatch(picAppError(`Problem: something went wrong fetching list of participants; Try again later `))
// });
// }


// WEBPACK FOOTER //
// ./src/apis/participant/getParticipants.js